import { isLocalhost } from '@/utils/utils';

export const PARENT_FRONTEND_PARAM = 'parent_frontend';
const PARENT_FRONTEND_CUSTOMER = 'customer';

const STENCIL_TEST_MFE_LOCAL_URL = 'http://localhost:3010';
const STENCIL_TEST_MFE_PROD_URL = 'https://stencil.sc-microfrontends.rio.cloud';

const NOTIFICATION_SETTINGS_MFE_LOCAL_URL = 'http://localhost:3002';
const NOTIFICATION_SETTINGS_MFE_PROD_URL = 'https://notificationsettings.sc-microfrontends.rio.cloud';

const HIGH_VOLTAGE_BATTERY_MFE_LOCAL_URL = 'http://localhost:3070';
const HIGH_VOLTAGE_BATTERY_MFE_PROD_URL = 'https://battery-service.vehiclestate.rio.cloud';

export const FEEDBACK_CARE_MFE_LOCAL_URL = 'http://localhost:3080';
export const FEEDBACK_CARE_MFE_PROD_URL = 'https://feedback-care.sc-microfrontends.rio.cloud';

const TYRES_MFE_LOCAL_URL = 'http://localhost:3120';
const TYRES_MFE_PROD_URL = 'https://tyres.vehiclestate.rio.cloud/';

const VEHICLE_WARNINGS_MFE_LOCAL_URL = 'http://localhost:3140';
const VEHICLE_WARNINGS_MFE_PROD_URL = 'https://vehicle-warnings.vehicleuptime.rio.cloud';

export const prepareUrl = (url: string): string => {
    const finalUrl = new URL(url);
    finalUrl.searchParams.set(PARENT_FRONTEND_PARAM, PARENT_FRONTEND_CUSTOMER);
    return finalUrl.toString();
};

const getUrl = (localUrl: string, prodUrl: string): string => {
    return prepareUrl(isLocalhost() ? localUrl : prodUrl);
};

export const STENCIL_TEST_MFE = {
    name: 'StencilTestMfe',
    initialDelay: 5000,
    url: getUrl(STENCIL_TEST_MFE_LOCAL_URL, STENCIL_TEST_MFE_PROD_URL),
    isAllowedTenant: true, // TODO add proper verification
};

export const NOTIFICATION_SETTINGS_MFE = {
    name: 'NotificationSettingsMfe',
    initialDelay: 5000,
    url: getUrl(NOTIFICATION_SETTINGS_MFE_LOCAL_URL, NOTIFICATION_SETTINGS_MFE_PROD_URL),
    isAllowedTenant: true, // TODO add proper verification
};

export const HIGH_VOLTAGE_BATTERY_MFE = {
    name: 'HighVoltageBatteryMfe',
    initialDelay: 5000,
    url: (assetId?: string) => {
        const baseUrl = getUrl(HIGH_VOLTAGE_BATTERY_MFE_LOCAL_URL, HIGH_VOLTAGE_BATTERY_MFE_PROD_URL);
        const finalUrl = new URL(baseUrl);
        if (assetId !== undefined) {
            finalUrl.hash = assetId;
        } else {
            finalUrl.hash = '/overview';
        }

        return finalUrl.toString();
    },
    dialogUrl: (assetId: string) => {
        const baseUrl = getUrl(HIGH_VOLTAGE_BATTERY_MFE_LOCAL_URL, HIGH_VOLTAGE_BATTERY_MFE_PROD_URL);
        const finalUrl = new URL(baseUrl);
        finalUrl.hash = `/dialog/${assetId}`;

        return finalUrl.toString();
    },
    isAllowedTenant: true, // TODO add proper verification
};

export const FEEDBACK_CARE_MFE = {
    name: 'FeedbackCareMfe',
    initialDelay: 5000,
    getMfeUrl: (localUrl: string, prodUrl: string, hash: string, queryParams: Record<string, string | undefined>) => {
        const finalUrl = new URL(isLocalhost() ? localUrl : prodUrl);
        finalUrl.searchParams.set(PARENT_FRONTEND_PARAM, PARENT_FRONTEND_CUSTOMER);
        Object.entries(queryParams).forEach(([key, value]) => {
            if (value !== undefined) {
                finalUrl.searchParams.append(key, value);
            }
        });
        const queryString = finalUrl.search;
        return `${finalUrl.origin}${finalUrl.pathname}${queryString}${hash}`;
    },
    isAllowedTenant: true, // TODO add proper verification
};

export const TYRES_MFE = {
    name: 'TyresMfe',
    initialDelay: 5000,
    url: (assetId: string) => {
        const baseUrl = getUrl(TYRES_MFE_LOCAL_URL, TYRES_MFE_PROD_URL);
        const finalUrl = new URL(baseUrl);
        finalUrl.hash = `/${assetId}`;
        return finalUrl.toString();
    },
    isAllowedTenant: true, // TODO add proper verification
};

export const VEHICLE_WARNINGS_MFE = {
    name: 'VehicleWarningsMfe',
    initialDelay: 5000,
    url: (assetId: string, expanded?: boolean) => {
        const baseUrl = getUrl(VEHICLE_WARNINGS_MFE_LOCAL_URL, VEHICLE_WARNINGS_MFE_PROD_URL);
        const finalUrl = new URL(baseUrl);
        if (expanded) {
            finalUrl.searchParams.set('expanded', 'true');
        }
        finalUrl.hash = `/${assetId}`;
        return finalUrl.toString();
    },
    isAllowedTenant: true, // TODO add proper verification
};
